module.exports = "<div class=\"filter-option-container\">\n    <div class=\"circle {{value}}\" ng-show=\"isStatus && value !== ''\"></div>\n    <div class=\"lead-status-filter\">{{label}}</div>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/pipeline/filter/filterOptions/filterOptionsTemplate.html
// module id = 254
// module chunks = 1